/**
 * Encounters Thunks
 * Async actions for fetching paginated encounters.
 * Supports `append: true` for infinite scroll (appends to existing data).
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as encountersApi from '../api/encountersApi';

export const fetchEncounters = createAsyncThunk(
  'emr/fetchEncounters',
  async ({ patientId, customerId, page, limit, type, append = false }, { getState, requestId, rejectWithValue }) => {
    try {
      // The list this answer belongs to: a first page starts a list (its own request), a
      // later page extends the list loaded when it was asked for. Answers for a list
      // replaced meanwhile are dropped (emrSlice).
      const listRequestId = append
        ? getState().emr?.encountersByPatient?.[patientId]?.listRequestId
        : requestId;
      // When the answer was asked for (a prefetched page: when the prefetch was sent)
      const timing = {};
      const data = await encountersApi.fetchEncounters({ patientId, customerId, page, limit, type, timing });
      return { patientId, ...data, append, requestedAt: timing.requestedAt, listRequestId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
